/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created on Mon Feb 28 2022 16:48:22 GMT+0100 (heure normale d’Europe centrale).
 *
 * Version : Generator 2.0.9 / Datatable 1.0.1
 */

/**
 *
 * FilterType Range
 */
export enum FilterType {
    'TRAVAIL' = 'TRAVAIL',
    'PORTE' = 'PORTE',
    'LARGEUR' = 'LARGEUR',
    'CHASSIS' = 'CHASSIS',
    'TIMON' = 'TIMON',
    'HERSE' = 'HERSE',
    'SEMOIR' = 'SEMOIR',
    'ROUE' = 'ROUE',
    'TRAVAIL_DENT' = 'TRAVAIL_DENT',
    'TRAVAIL_DISQUE' = 'TRAVAIL_DISQUE',
    'TRAVAIL_HERSE' = 'TRAVAIL_HERSE',
}
/**
 *
 * Lang Range
 */
export enum Lang {
    'fr' = 'fr',
    'en' = 'en',
    'de' = 'de',
}
/**
 *
 * MediaType Range
 */
export enum MediaType {
    'IMAGE' = 'IMAGE',
    'VIDEO' = 'VIDEO',
    'PDF' = 'PDF',
    'DIRECTORY' = 'DIRECTORY',
}
/**
 *
 * DocumentType Range
 */
export enum DocumentType {
    'MENU' = 'MENU',
    'DOCUMENT' = 'DOCUMENT',
    'GALLERY' = 'GALLERY',
}
/**
 *
 * TravailType Range
 */
export enum TravailType {
    'TRAVAIL_DENT' = 'TRAVAIL_DENT',
    'TRAVAIL_DISQUE' = 'TRAVAIL_DISQUE',
    'TRAVAIL_HERSE' = 'TRAVAIL_HERSE',
}
